import { Component, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';

import { EventService } from '@shared/event.service';
import { ProjectGroup } from '@shared/services/project-group.model';
import { TranslateService } from '@ngx-translate/core';
import { ProgressService } from '@global/services/progress.service';
import { finalize } from 'rxjs';
import { SubmitBidService } from './submit-bid.service';

@Component({
  selector: 'oes-portfolio-submit-bid',
  templateUrl: './submit-bid.component.html',
  styleUrls: ['./submit-bid.component.scss'],
  providers: [
    SubmitBidService
  ]
})
export class PortfolioSubmitBidComponent {
  @Input() projectGroupId: string;
  @Output() completed: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('bidWithdrawalConfirmation', {static: false}) bidWithdrawalConfirmation: ModalDirective;

  constructor(private _eventService: EventService,
              private _progressService: ProgressService,
              private _translateService: TranslateService,
              private _submitBidService: SubmitBidService) {
  }

  openDialog(projectGroupId) {
    this.projectGroupId = projectGroupId;
    this.bidWithdrawalConfirmation.show();
  }

  submitBid(projectGroup: ProjectGroup) {
    this._progressService.setSpinner(true);
    this.projectGroupId = projectGroup.id;
    this._submitBidService.submitBid(this.projectGroupId)
    .pipe(finalize(() => {
      this._progressService.setSpinner(false);
    }))
    .subscribe(financeConnection => {
      this._eventService.success(this._translateService.instant('success-message.bid-submitted-to') + ' ' + projectGroup.program.name + ' ' + this._translateService.instant('success-message.program'));
      this.completed.emit(true);
    });
  }

  resubmitBid(projectGroup: ProjectGroup) {
    this._progressService.setSpinner(true);
    this._submitBidService.resubmitBid(projectGroup.id)
    .pipe(finalize(() => {
      this._progressService.setSpinner(false);
    }))
    .subscribe(response => {
      this.bidWithdrawalConfirmation.hide();
      this._eventService.success(this._translateService.instant('success-message.bid-submitted-to') + ' ' + projectGroup.program.name + ' ' + this._translateService.instant('success-message.program'));
      this.completed.emit(true);
    });
  }

  withdrawBid() {
    this._progressService.setSpinner(true);
    this._submitBidService.withdrawBid(this.projectGroupId)
    .pipe(finalize(() => {
      this._progressService.setSpinner(false);
    }))
    .subscribe(() => {
      this.bidWithdrawalConfirmation.hide();
      this._eventService.success(this._translateService.instant('success-message.bid-withdrawn'));
      this.completed.emit(true);
    });
  }

  closeDialog() {
    this.bidWithdrawalConfirmation.hide();
  }
}
